(function () {
  document.querySelectorAll('[data-sk-chub]').forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-chub-target]'));
    const panels = Array.from(root.querySelectorAll('[data-chub-panel]'));

    function activate(tab) {
      tabs.forEach((t) => {
        t.classList.remove('active');
        t.setAttribute('aria-selected', 'false');
      });
      tab.classList.add('active');
      tab.setAttribute('aria-selected', 'true');

      const targetId = tab.dataset.chubTarget;
      panels.forEach((panel) => {
        panel.classList.toggle('hidden', panel.id !== targetId);
      });
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => activate(tab));
    });

    const params = new URLSearchParams(window.location.search);
    const requestedHandle = params.get('tab');
    if (requestedHandle) {
      const match = tabs.find((t) => t.dataset.chubHandle === requestedHandle);
      if (match) {
        activate(match);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
})();
